import React from "react";
import {Button, Card, Col, Input, message, Modal, Radio, Row, Select} from "antd";
import './index.less'
import classnames from 'classnames'
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import MyButton from "../../../../components/Button";
import {getRemodelWindowInfo, getRemodelWindowSave, getProductQueryProducts} from "../../../../constants/api";
import {removeToken} from "../../../../utils/cookie";

import {COMMON_ROUTER} from "../../../../constants";

const {Option} = Select
export default class Showcase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      decorationWindowRelationId: '',
      windowType: '',
      windowName: '',
      windowStatus: '',
      shopId: '',
      templateId: '',
      products: [],//商品
      addVisible: false,

      platformType: null
    }
  }


  componentWillMount() {
    if (this.props.location.state) {
      console.log(this.props.location.state)
      this.setState({
        templateId: this.props.location.state.templateId,
        shopId: this.props.location.state.shopId
      }, () => console.log(this.state.templateId, this.state.shopId))
    }
  }

  componentDidMount() {
    this.getTemplateId()
  }

  getTemplateId = () => {
    let storage = window.localStorage;
    let templateId = storage.getItem('templateId');
    let platformType = storage.getItem('platformType')
    if (templateId && platformType) {
      this.setState({
        templateId: templateId,
        platformType: platformType
      }, () => {
        this.getShowcase(templateId, platformType);
        this.getGoodsCategory(templateId, platformType);
      })
    } else {
      message.error('请先选择总店', 1)
    }
  }

  getShowcase(templateId, platformType) {
    getRemodelWindowInfo({
      id: this.state.templateId,
      shopId: this.state.shopId,
      templateId: templateId,
      platformType: platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let products = data.data.products;
          let selectId = [];
          products.map((item, index) => {

            selectId.push(item.productRelationId)
          })
          console.log(selectId)
          this.setState({
            decorationWindowRelationId: data.data.decorationWindowRelationId,
            windowType: data.data.windowType,
            windowName: data.data.windowName,
            windowStatus: data.data.windowStatus,
            products: data.data.products,
            selectId: selectId
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_WINDOW, {
    //   // shopIds: this.state.shopId,
    //   id: this.state.templateId,
    //   shopId: this.state.shopId,
    //   templateId: templateId,
    //   platformType: platformType
    // }).then(res => {
    //   console.log(res)
    //   console.log('$$$$$$$$$$$$$$$$$$')
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let products = data.data.products;
    //       let selectId = [];
    //       products.map((item, index) => {
    //
    //         selectId.push(item.productRelationId)
    //       })
    //       console.log(selectId)
    //       this.setState({
    //         decorationWindowRelationId: data.data.decorationWindowRelationId,
    //         windowType: data.data.windowType,
    //         windowName: data.data.windowName,
    //         windowStatus: data.data.windowStatus,
    //         products: data.data.products,
    //         selectId: selectId
    //       })
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  getGoodsCategory(templateId, platformType) {
    getProductQueryProducts({
      shopId: this.state.shopId,
      templateId: templateId,
      platformType: platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            goodscategory: data.data
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_CATEGORY, {
    //   // shopIds: this.state.shopId,
    //   // id: this.state.shopId,
    //   shopId: this.state.shopId,
    //   templateId: templateId,
    //   platformType: platformType
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       this.setState({
    //         goodscategory: data.data
    //       })
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  handleChange = (type, e) => {
    switch (type) {
      case 'status':
        this.setState({
          windowStatus: e.target.value
        })
        break;
      case 'name':
        this.setState({
          windowName: e.target.value
        })
        break;
      case 'pattern':
        this.setState({
          windowType: e.target.value
        })
        break;
      case 'product':
        console.log(e)
        this.setState({
          selectId: e
        })
        break;


    }
  }

  delete = (index) => {
    let products = this.state.products;
    console.log(products)
    products.splice(index, 1)
    let selectId = [];
    products.map((item, index) => {
      selectId.push(item.productRelationId)
    })
    this.setState({
      products: products,
      selectId: selectId
    })
  }

  setModal = () => {
    this.setState({
      addVisible: true
    })
  }

  handleCancel = () => {
    if (!(this.state.selectId.length >= 3 && this.state.selectId.length <= 8)) {
      message.error('商品数必须在3-8个之间', 1)
      return
    }
    let selectId = [];
    this.state.products.map((item, index) => {
      selectId.push(item.productRelationId)
    })
    this.setState({
      addVisible: false,
      selectId: selectId
    })
  }
  handleOk = () => {
    if (!(this.state.selectId.length >= 3 && this.state.selectId.length <= 8)) {
      message.error('商品数必须在3-8个之间', 1)
      return
    }
    let goodscategory = this.state.goodscategory
    let selectId = this.state.selectId
    let new_products = [];
    console.log(selectId)
    console.log(goodscategory)
    goodscategory.map((item, index) => {
      if (selectId.includes(item.productRelationId)) {
        console.log('------------')
        new_products.push(item)
      }
    })
    this.setState({
      products: new_products,
      addVisible: false
    })
  }

  submit = () => {
    getRemodelWindowSave({
      productIds: this.state.selectId,
      windowName: this.state.windowName,
      windowStatus: this.state.windowStatus,
      windowType: this.state.windowType,
      shopId: this.state.shopId,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          console.log(this.props.history)
          this.props.history.push(COMMON_ROUTER + '/shopRenovation')
          message.success('发布成功', 1)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_WINDOW_SAVE, {
    //   productIds: this.state.selectId,
    //   windowName: this.state.windowName,
    //   windowStatus: this.state.windowStatus,
    //   windowType: this.state.windowType,
    //   shopId: this.state.shopId,
    //   templateId: this.state.templateId
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       console.log(this.props.history)
    //       this.props.history.push(COMMON_ROUTER + '/shopRenovation')
    //       message.success('发布成功', 1)
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }
/**
 * @Description: 返回上一层
 * @Author Jiang
 * @Date 2020/8/17 14:00
*/
  cancel = () => {
    this.props.history.push(COMMON_ROUTER + '/shopRenovation')
  }


  render() {
    let {windowStatus, windowType, windowName, products, selectId} = this.state
    console.log(selectId)
    return (
      <Card style={{width: '100%'}} title={'编辑橱窗'}>
        {/*橱窗状态*/}
        <Row justify={'center'}>
          <Col className='row'>
            <div className='case-title'>
              <div className='text-title'>
                橱窗状态
              </div>
              <div>
                <Radio.Group className='select' value={windowStatus}
                             onChange={this.handleChange.bind(this, 'status')}>
                  <Radio value="OPEN">开启</Radio>
                  <Radio value="CLOSE">关闭</Radio>
                </Radio.Group>
              </div>
            </div>
          </Col>
        </Row>
        {this.state.windowStatus === "OPEN" ? <div>
          {/*橱窗标题*/}
          <Row justify={'center'}>
            <Col>
              <div className='title'>
                <div className='text-title'>
                  橱窗标题
                  <div className='tips'>
                    展示在你的店铺页，顾客可见
                  </div>
                </div>
                <div>
                  <Input defaultValue={windowName} value={windowName} onChange={this.handleChange.bind(this, 'name')}
                         style={{width: '400px', height: '40px', borderRadius: '12px', marginTop: '10px'}}/>
                </div>
              </div>
            </Col>
          </Row>
          {/*橱窗商品*/}
          <Row justify={'center'}>
            <Col>
              <div className={classnames('case-title', 'window')}>
                <div className='text-title'>
                  橱窗商品
                </div>
                <div>
                  <Radio.Group className='select' value={windowType}
                               onChange={this.handleChange.bind(this, 'pattern')}>
                    <Radio value="AUTO_RECOMMEND">智能模式</Radio>
                    <Radio value="CUSTOM_SETTING">自定义模式</Radio>
                  </Radio.Group>
                </div>
              </div>
              <div className='tips'>
                 3-8 个商品， 当商品因下架或删除低于3个时，橱窗将不在用户端展示
              </div>
            </Col>
          </Row>
          <Row justify={'center'}>
            {/*商品*/}
            <Col>
              <div className={classnames('title', 'window')}>
                {products && products.map((product, index) => {
                  return <div key={index}>
                    <div className='shop-row'>
                      <div>
                        {product.productName}
                      </div>
                      <Button style={{borderWidth: 0}} onClick={this.delete.bind(this, index)}>
                        <div>
                          <DeleteOutlined/>移除
                        </div>
                      </Button>
                    </div>

                  </div>
                })}
                {
                  products.length <= 7 ? <div className={classnames('add-goods', 'row-bottom')}>
                    <Button onClick={this.setModal.bind(this)} type={'primary'}>添加商品</Button>
                  </div> : null
                }
              </div>
            </Col>
          </Row>

        </div> : null
        }
        <Row justify='center'>
          <Col>
            <div className='title-btn'>
              <MyButton title={'取消'} onClick={this.cancel.bind(this)}/>
              <MyButton title={'确认发布'} onClick={this.submit.bind(this)} type={'primary'}/>
            </div>
          </Col>
        </Row>

        <Modal
          title="关联商品"
          visible={this.state.addVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确认"
          cancelText="取消"
        >
          <Select style={{width: "400px"}} value={this.state.selectId}
                  onChange={this.handleChange.bind(this, 'product')} mode="multiple">
            {this.state.goodscategory && this.state.goodscategory.map((item, index) => {
              return <Option key={this.state.shopId === 0?item.productId:item.productRelationId}
                             value={this.state.shopId === 0?item.productId:item.productRelationId}>{item.productName}</Option>
            })}
          </Select>
        </Modal>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopmanage/shoprenovation/showcase/index.js